import React from 'react'
import Filtro from '../comum/Filtro'
import FiltrosAdicionadosCteOs from './FiltrosAdicionadosCteOs'
import FiltroCteOs from './FiltroCteOs'
import PainelFiltragem from '../comum/PainelFiltragem'

export const PainelFiltroCteOs = () => (
  <Filtro PainelFiltro={FiltroCteOs}/>
);

const PainelFiltrosCteOs = () => (
  <PainelFiltragem
    Filtro={PainelFiltroCteOs}
    FiltrosAdicionados={FiltrosAdicionadosCteOs}/>
)

export default PainelFiltrosCteOs
